module.exports = __webpack_public_path__ + "static/img/dfh1.2ae3bac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dfh1.png
// module id = t1dB
// module chunks = 1